// Единая матрица доступности «аддон × тариф» для обоих движков (public /price/ и *-v424).
// Раньше дублировалась: options[] в useAddonsList и pattern[] в useAddonsFull (и уже разошлась —
// editorBee[marketing] был "price" в одном и 1 в другом; на публичной эта ячейка не рендерится).
//
// Порядок колонок (индексы 0..5):
//   [core, support, marketing, marketingExpert, enterpriseMarketing, enterpriseSupport]
// Значение ячейки:
//   "price" — платно; конкретную цену подставляет каждый движок (из калькулятора или фикс.)
//   1 — входит в тариф
//   0 — недоступно
//   2 — по запросу
export type AddonCell = "price" | 0 | 1 | 2

export const ADDON_COLUMNS = ["core", "support", "marketing", "marketingExpert", "enterpriseMarketing", "enterpriseSupport"] as const

export const ADDON_PATTERNS: Record<string, AddonCell[]> = {
  noBranding: ["price", "price", "price", "price", 1, 1],
  support: ["price", 1, "price", "price", 1, "price"],
  welcome: ["price", "price", "price", 1, 1, 1],
  aiBot: ["price", "price", "price", "price", "price", "price"],
  editorBee: ["price", "price", 1, 1, 1, 1],
  messengers: ["price", "price", "price", "price", "price", "price"],
  email: ["price", "price", "price", "price", 2, "price"],
}
